
/**
 * +-------------------------------------------------+
 * |                                                 |
 * | Function Global Untuk Date Utils Alert 2        |
 * +_________________________________________________+
 * 
 * Asalkan function mixin dan vue componentnya sama pagination bisa berjalan
 */
import DataKeanggotaanService from "../services/keanggotaan/data-anggota.service";

export const DataKeanggotaan = {
  data() {
    return {
      optionDataAnggota : [],
      optionCalonAnggota : [],
      multi_data_anggota : [],
      multi_calon_anggota : [],
      items_data_anggota : [],
      items_calon_anggota : []
    };
  },
  methods: {
    getAllDataAnggota() {
      DataKeanggotaanService.getAllDataAnggota()
      .then(response => {
          this.optionDataAnggota = response.data.data
          this.items_data_anggota = response.data.data 
      }).catch(error => {
          // comment console console.log(error)
      })
    },
    getAllCalonAnggota() {
      /**
       * set logic
       */
    },
  }
};